import { render } from "./PageNotFound.vue?vue&type=template&id=615e6c78&scoped=true"
const script = {}

import "./PageNotFound.vue?vue&type=style&index=0&id=615e6c78&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615e6c78"]])

export default __exports__